import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locals/en_US'
import es from './locals/es_MX'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'es',
  silentTranslationWarn: true,
  messages: {
    en: {
      "ERROR":"TAG ERROR",
      lang: en
    },
    es: {
      "ERROR":"TAG ERROR",
      "LOGIN_ERROR":"Nombre de usuario o contraseña equivocado",
      "CONNECTION_ERROR":"Error de conexión",
      lang: es
    }
  }
})